import { types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
import { AxiosResponse } from "axios";

export default {
    async modify(groupIdx: number, idx: number, param: types.ReqActionCitizen): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/action/citizen/modify/${groupIdx}/${idx}`, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async modifyRound(groupIdx: number, roundIdx: number, idx: number, param: types.ReqActionCitizenForRound): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/action/citizen/modify/round/${groupIdx}/${roundIdx}/${idx}`, param, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async list(groupIdx: number, param: types.ReqCommonPaging): Promise<types.ResActionCitizenForAPi> {
        const res = {} as types.ResActionCitizenForAPi;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/action/citizen/list/${groupIdx}`, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async memberList(groupIdx: number, param: types.ReqCommonPaging): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/action/citizen/list/wait/${groupIdx}`, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async excelDownload(groupIdx: number, param: types.ReqIdxList): Promise<any> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post(`/action/citizen/export/excel/${groupIdx}`, param, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async detail(idx: number): Promise<any> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/action/citizen/detail/${idx}`, {}, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async change(idx: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/action/citizen/change/${idx}`, {}, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async add(groupIdx: number, idx: number, param: types.ReqActionCitizen): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/action/citizen/add/${groupIdx}/${idx}`, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
};
